<template>
  <d-modal v-if="orderStatusKey !== null" @close="handleClose">
    <d-modal-header>
      <d-modal-title>Confirm Delete</d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <p>Deleting an Order Status cannot be undone.</p>
      <p></p>
      <p>
        To enable the confirm delete button, please type the following code:
      </p>
      <pre class="text-danger" style="font-size: 1.2rem">{{ confirmTest }}</pre>
      <d-form-input
        :state="confirmValueState"
        type="text"
        placeholder="confirm"
        class="mb-2"
        v-model="confirmValue"
      ></d-form-input>
    </d-modal-body>
    <d-modal-footer>
      <div class="d-flex text-monospace text-danger">
        {{ errorMsg }}
      </div>

      <d-button class="mx-2" theme="light" @click="handleClose">
        Cancel
      </d-button>
      <async-button
        :disabled="confirmValueState !== true"
        @click="deleteOrderStatus"
        text="Delete"
        loadingText="Deleting..."
        theme="danger"
        :loading="deleting"
      />
    </d-modal-footer>
  </d-modal>
</template>

<script>
export default {
  data() {
    return {
      deleting: false,
      confirmValue: "",
      errorMsg: ""
    };
  },
  props: {
    orderStatusKey: {
      type: String,
      default: null
    }
  },
  computed: {
    confirmTest() {
      return this.orderStatusKey.substring(0, 5);
    },
    confirmValueState() {
      return this.confirmValue === this.confirmTest ? true : undefined;
    }
  },
  watch: {
    orderStatusKey(newValue) {
      this.resetForm();
    }
  },
  methods: {
    resetForm() {
      this.confirmValue = "";
      this.errorMsg = "";
    },
    handleClose() {
      this.$emit("close", false);
    },
    deleteOrderStatus() {
      this.deleting = true;
      this.errorMsg = "";
      this.$store
        .dispatch("orderStatusOptions/delete", this.orderStatusKey)
        .then(() => {
          this.$emit("dataUpdated");
          this.handleClose();
        })
        .catch(error => {
          this.errorMsg = `ERROR ${error.response.status}: ${error.response.data}`;
        })
        .finally(() => {
          this.deleting = false;
        });
    }
  }
};
</script>

<style></style>
